import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login';
import { AuthCallbackComponent } from './pages/auth-callback/auth-callback';

export const authRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'callback', component: AuthCallbackComponent }
];